/*==========================*/
/* imagesLoaded plugin */
/*==========================*/

/*
 * jQuery imagesLoaded plugin v2.0.1
 * http://github.com/desandro/imagesloaded
 *
 * MIT License. by Paul Irish et al.
 */

(function(c,n){var k="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///ywAAAAAAQABAAACAUwAOw==";c.fn.imagesLoaded=function(l){function m(){var b=c(h),a=c(g);d&&(g.length?d.reject(e,b,a):d.resolve(e));c.isFunction(l)&&l.call(f,e,b,a)}function i(b,a){b.src===k||-1!==c.inArray(b,j)||(j.push(b),a?g.push(b):h.push(b),c.data(b,"imagesLoaded",{isBroken:a,src:b.src}),o&&d.notifyWith(c(b),[a,e,c(h),c(g)]),e.length===j.length&&(setTimeout(m),e.unbind(".imagesLoaded")))}var f=this,d=c.isFunction(c.Deferred)?c.Deferred():
0,o=c.isFunction(d.notify),e=f.find("img").add(f.filter("img")),j=[],h=[],g=[];e.length?e.bind("load.imagesLoaded error.imagesLoaded",function(b){i(b.target,"error"===b.type)}).each(function(b,a){var e=a.src,d=c.data(a,"imagesLoaded");if(d&&d.src===e)i(a,d.isBroken);else if(a.complete&&a.naturalWidth!==n)i(a,0===a.naturalWidth||0===a.naturalHeight);else if(a.readyState||a.complete)a.src=k,a.src=e}):m();return d?d.promise(f):f}})(jQuery);

/*==========================*/
/* Global Variables */
/*==========================*/

var   THE_BODY              = $('body'),
      HEADER                = $('#header'),
      FOOTER                = $('#footer'),
      IS_INDEX              = (THE_BODY.hasClass('template-index')) ? true : false,
      IS_COLLECTION         = (THE_BODY.hasClass('template-collection')) ? true : false,
      IS_COLLECTION_LISTING = ($('#collection-list').length > 0) ? true : false,
      IS_PRODUCT            = (THE_BODY.hasClass('template-product')) ? true : false,
      IS_BLOG               = (THE_BODY.hasClass('template-blog')) ? true : false,
      IS_ARTICLE            = (THE_BODY.hasClass('template-article')) ? true : false,
      IS_SEARCH             = (THE_BODY.hasClass('template-search')) ? true : false,
      IS_CART               = (THE_BODY.hasClass('template-cart')) ? true : false,
      HAS_CURRENCIES        = (HEADER.hasClass('currencies')) ? true : false;

$('html').removeClass('no-js');

/* Global JS */
/*==========================*/

/* loadImages function */
/* elems are the images, and ch is the container height */
/* Sizes image appropriately to fill as much of the container as possible
   without cropping it, and making sure the image is vertically aligned */
var loadImages = function(elems, ch) {

    $(elems).each(function(){
        $(this).imagesLoaded( function() {
            var i_w = $(this).width();  // image width
            var i_h = $(this).height(); // image height
            var c_h = ch;               // container height
            var v_o = (c_h - i_h) / 2;  // vertical offset            
            if ( i_h > c_h ) {
                $(this).css('height',ch).css('width','auto');
            } else {
                $(this).css('margin-top',v_o);
            }   
            $(this).fadeTo(200,1); // reveals image with a 200 ms-lomg fade-in.
        });
    });
}

/* Index JS */
/*==========================*/
if (IS_INDEX) {
    $html_slider = '';
    $html_mobile_slider = '';
    
    $html_slider =
                    '<div id="slider-top" class="slider main-slider">' + 
                        '<div id="iview" class="slider-wrap">' +
                        
                            
                            
                            
                            

                            
                            '<div data-iview:image="//arloji-dev-shop.myshopify.com/cdn/shop/t/4/assets/slide_1.jpg?v=1370396703">' +
                                
                                
                            '</div>' +
                            

                        
                            
                            
                            
                            

                            
                            '<div data-iview:image="//arloji-dev-shop.myshopify.com/cdn/shop/t/4/assets/slide_2.jpg?v=1370396704">' +
                                
                                
                            '</div>' +
                            

                        
                            
                            
                            
                            

                            
                            '<div data-iview:image="//arloji-dev-shop.myshopify.com/cdn/shop/t/4/assets/slide_3.jpg?v=1370395841">' +
                                
                                
                            '</div>' +
                            

                        
                            
                            
                            
                            

                            

                        
                            
                            
                            
                            

                            

                        
                        '</div><!-- End #iview .slider-wrap -->' + 
                    '</div><!-- #slider-top .slider -->';
     
    //console.log($html_slider);

     
    //console.log($html_mobile_slider);
    
    
    if (Modernizr.mq('only screen and (min-width:481px)')==true) { /* Bigger than mobile, display normal slider */
         $('#slider').append($html_slider);
    }
        

     
    
    // IE 8-9 does not understand Modernizr.mq, so it always return false.
    // in that case, just display the normal slider. (nobody is using IE 8-9 in mobile resolution)
    if (Modernizr.mq() == false) {
      $('#slider').append($html_slider);
    }
     
    
    if(($html_slider != '') || ($html_mobile_slider != '')) {    
        $('#iview').iView({
            pauseTime: 6000,
            pauseOnHover: true,
            controlNav: false,            
            directionNavHoverOpacity: 0,
            timer: "Bar",
            timerDiameter: "50%",
            timerPadding: 0,
            timerStroke: 7,
            timerBarStroke: 0,
            timerColor: "#C5925B",
            timerPosition: "bottom-right"
        });
    }
        

}


/* Product JS */
/*==========================*/
if (IS_PRODUCT) {

    // Format Thumbnails
    loadImages('.product-photo-thumb img',114);
    
    // Activate Colorbox
    $('a.gallery').colorbox( {
        rel:'gallery',
        maxWidth:"95%",
        maxHeight:"95%",
        scalePhotos:true} );

    var product_container = $('#product-photo-container');      

    // Initialize first photo
    product_container.find('img:first').imagesLoaded(function(){
        var elem = $(this);
        elem.addClass('active').fadeIn(100);
        product_container.css('height',elem.height());
        elem.parent().css( {'height':elem.height(), 'width':elem.width()} );
    });

    // Display new photo
    $('.product-photo-thumb').click(function(){

        var active_index = $(this).index();
        var photo_to_show = product_container.find('img').eq(active_index);
        var photo_to_hide = product_container.find('.active');

        photo_to_hide.fadeOut(100, function(){
            photo_to_hide.removeClass('active');
            photo_to_hide.parent().css( {'height':0, 'width':0} );
            var photo_to_show = product_container.find('img').eq(active_index);
            photo_to_show.imagesLoaded(function(){
                product_container.animate({height:photo_to_show.height()},200,function(){
                    photo_to_show.fadeIn(100, function(){
                        $(this).addClass('active');
                        $(this).parent().css( {'height':$(this).height(), 'width':$(this).width()} );
                    });
                });
            });
        });
    });     
}

/* Everywhere */
/*==========================*/
$(document).ready(function(){  

    function relativeTime(time_value) {
        var parsed_date = parseDate(time_value);
        var relative_to = (arguments.length > 1) ? arguments[1] : new Date();
        var delta = parseInt((relative_to.getTime() - parsed_date) / 1000);
        if(delta < 60) {
            return 'less than a minute ago';
        } else if(delta < 120) {
            return 'about a minute ago';
        } else if(delta < (45*60)) {
            return (parseInt(delta / 60)).toString() + ' minutes ago';
        } else if(delta < (90*60)) {
            return 'about an hour ago';
        } else if(delta < (24*60*60)) {
            return 'about ' + (parseInt(delta / 3600)).toString() + ' hours ago';
        } else if(delta < (48*60*60)) {
            return '1 day ago';
        } else {
            return (parseInt(delta / 86400)).toString() + ' days ago';
        }
    }

    function parseDate(str) {
        var v=str.split(' '), year, time;
        // date string from tumblr's tweet data is slightly different from twitter timeline data
        if (/\+0000/.test(v[5])) {
            year = v[3];
            time = v[4]
        } else {
            year = v[5]
            time = v[3]
        }
        return new Date(Date.parse(v[1]+" "+v[2]+", "+year+" "+time+" UTC"));
    }

  
    /* customer address helper */
    Shopify.CustomerAddress = {
      toggleForm: function(id) {
        var editEl = document.getElementById('edit_address_'+id);
        var viewEl = document.getElementById('view_address_'+id);      
        editEl.style.display = editEl.style.display == 'none' ? '' : 'none';
        viewEl.style.display = viewEl.style.display == 'none' ? '' : 'none';
        return false;    
      },
      
      toggleNewForm: function() {
        var el = document.getElementById('add_address');
        el.style.display = el.style.display == 'none' ? '' : 'none';
        return false;
      },
      
      destroy: function(id, confirm_msg) {
        if (confirm(confirm_msg || "Are you sure you wish to delete this address?")) {
          Shopify.postLink('/account/addresses/'+id, {'parameters': {'_method': 'delete'}});
        }      
      }
    }

    /* numeric check */
    $(".positive-integer").numeric({ decimal: false, negative: false }, function() { alert("Positive integers only"); this.value = ""; this.focus(); });

});
     
$(function() {
    console.log("firing masonry");

    // or with jQuery
    var $container = $('.list-items');
    // initialize Masonry after all images have loaded  
    $container.imagesLoaded( function() {
      $container.masonry();
    });

    console.log("--masonry fired.");  
});